import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {DragDropModule} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-warning-with-skip',
  templateUrl: './warning-with-skip.component.html'
})
export class WarningWithSkipComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WarningWithSkipComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
